import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_BILLING_HISTORY_LIST, GET_BILLING_HISTORY_PDF } from "../../../../Urls.js";

const initialState = {
    billingHistoriesData: { data: [], loading: false },
};

export const getBillingHistory = createAsyncThunk(
    "app/get/payement/getBillingHistory",
    async (payload) => {
        const response = await axios.post(GET_BILLING_HISTORY_LIST, { ...payload });
        return response;
    }
);
export const getBillingHistoryPdf = createAsyncThunk(
    "app/get/payement/downloadBillingHistory",
    async (payload) => {
        const response = await axios.post(GET_BILLING_HISTORY_PDF, { ...payload });
        return response;
    }
);


export const billingSlice = createSlice({
    name: "billingSlice/billing",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBillingHistory.pending, (state) => {
                state.billingHistoriesData.loading = true;
            })
            .addCase(getBillingHistory.fulfilled, (state, action) => {
                state.billingHistoriesData.loading = false;
                state.billingHistoriesData.data = action?.payload?.data?.data;
            })
            .addCase(getBillingHistory.rejected, (state) => {
                state.billingHistoriesData.loading = false;
                state.billingHistoriesData.data =[];
            })
    }
});


export const { } = billingSlice.actions;

export default billingSlice.reducer;